import React from "react";
import { CtaButton } from "./CtaButton";
type CtaBandProps = {
  label: string;
  sub?: string;
};
export function CtaBand({
  label,
  sub
}: CtaBandProps) {
  return <div className="flex w-full justify-center bg-white px-5 pb-14" data-id="element-67" data-mp="2g0g4t2anybol">
      <CtaButton label={label} sub={sub} data-id="element-68" data-mp="2usro1r39wdlc" />
    </div>;
}